import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';

@Component({
  selector: 'app-change-customer-filter',
  templateUrl: './change-customer-filter.component.html',
  styleUrls: ['./change-customer-filter.component.scss'],
})
export class ChangeCustomerFilterComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  private filterMode = false;

  public selectedRow: any;
  public changeCustomerFormGroup: FormGroup;

  constructor(public authService: AuthService) {
    this.changeCustomerFormGroup = new FormGroup({
      custid: new FormControl(''),
    });
  }

  ngOnInit() {
    this.changeCustomerFormGroup.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => this.authService.customerDialogFilter$.next(data));

    this.authService.changeCustomerDialog$
      .pipe(
        filter((x) => !!x),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.resetForm());

    this.authService.changeCustomerFilterMode.pipe(takeUntil(this.destroy$)).subscribe((x) => (this.filterMode = x));
    this.authService.selectedCustomerRow$.pipe(takeUntil(this.destroy$)).subscribe((row) => (this.selectedRow = row));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  resetForm() {
    this.authService.customerDialogFilter$.next(null);
    this.changeCustomerFormGroup.reset({
      custid: '',
    });
  }

  public goBack() {
    if (this.filterMode) {
      this.authService.changeCustomerDismissDialog.next(true);
      return;
    }
    this.authService.changeCustomerShowing.next('grid');
  }
}
